import React, {useRef} from "react";
import Productionissues from "./Productionissues";
import Productionrepair from "./Productionrepair";
import Productreturn from "./Productreturn";
import Productioncycle from "./Productioncycle";
import Leadtime from "./Leadtime";
export default function Productiontable() {

  const issueRef = useRef(null); 
  const repairRef = useRef(null); 
  const returnRef = useRef(null); 
  const productionRef = useRef(null); 

  const handleScroll = (ref) => {
    console.log("scrool down")
    window.scrollTo({
      top: ref.offsetTop,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <div>
      <div class="flex flex-wrap justify-center mt-6">
        <div class="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl  " onClick={() => {handleScroll(issueRef.current);}}>
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative top-1.5 left-1.5"
                  width="48"
                  height="48"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="9" stroke="#1F78B4" />
                  <path d="M9.0001 14.9998L15.0001 8.99976" stroke="#1F78B4" />
                  <path d="M15 15L9 9" stroke="#1F78B4" />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">753</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold">
            Outsanding Issues
          </h1>
          <p className="text-red-600 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#F32626"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#F32626"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">03.88%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div class="w-full flex-1 sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-2 shadow-md shadow-slate-400 bg-white rounded-xl" onClick={() => {handleScroll(repairRef.current);}}>
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-28 h-28  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="inline-block "
                  width="85"
                  height="85"
                  viewBox="0 0 75 75"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1_2734)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M33.7719 71.875H41.2281C42.4125 68.425 43.3156 64.2156 47.8125 62.3438C52.4875 60.4156 56.1437 62.9562 59.1719 64.4437L64.4406 59.1688C62.8531 55.8969 60.4844 52.2969 62.35 47.7906C64.1219 43.5125 67.7844 42.5938 71.875 41.2313V33.7687C68.0156 32.4531 64.1531 31.5563 62.3531 27.2125C60.5656 22.9 62.5312 19.7281 64.4437 15.8281L59.1719 10.5594C55.6813 12.2688 52.2313 14.4875 47.7906 12.6469C43.4969 10.8625 42.6156 7.22813 41.2281 3.125H33.7719C32.4469 6.97187 31.5719 10.8375 27.2125 12.6438C26.0719 13.1219 24.9688 13.35 23.8469 13.35C21.2125 13.35 19.0375 12.125 15.8281 10.5594L10.5562 15.8281C12.35 19.5 14.4656 22.8188 12.6469 27.2125C10.8625 31.5094 7.22813 32.3812 3.125 33.7687V41.2313C6.95625 42.5375 10.8375 43.4344 12.6469 47.7875C14.4625 52.1719 12.4125 55.3875 10.5562 59.1719L15.8281 64.4437C20.3594 62.1781 23.1875 60.6812 27.2094 62.3531C31.5156 64.1406 32.3813 67.7844 33.7719 71.875ZM43.4406 75H31.5562C29.4281 69.0062 29.1031 66.5219 26.0156 65.2406C22.875 63.9313 20.6063 65.6531 15.1844 68.2156L6.78125 59.8125C9.50937 54.0719 11.0531 52.1094 9.75937 48.9844C8.47187 45.8875 6.03438 45.5875 0 43.4438V31.5562C5.95625 29.4375 8.475 29.1125 9.75937 26.0156C11.0437 22.9188 9.5375 20.975 6.78125 15.1844L15.1844 6.78438C20.625 9.37188 22.8906 11.05 26.0125 9.7625C29.1125 8.475 29.3938 6.05937 31.5594 0H43.4406C45.5719 5.99375 45.9031 8.48125 48.9844 9.75937C52.1125 11.0594 54.325 9.3875 59.8188 6.78438L68.2156 15.1844C65.4719 20.9563 63.9625 22.925 65.2406 26.0125C66.525 29.1125 68.9656 29.4094 75 31.5562V43.4469C69.0437 45.5625 66.5219 45.8906 65.2375 48.9875C63.9781 52.0344 65.375 53.8656 68.2188 59.8125L59.8188 68.2156C54.4188 65.6531 52.1094 63.9344 49.0187 65.2313C45.9312 66.5125 45.6437 68.8125 43.4406 75Z"
                      fill="#1F78B4"
                      stroke="#1F78B4"
                      stroke-width="0.5"
                    />
                    <path
                      d="M19.6289 35.0039H21.4336C22.0117 35.0039 22.4883 34.9062 22.8633 34.7109C23.2383 34.5078 23.5156 34.2266 23.6953 33.8672C23.8828 33.5 23.9766 33.0742 23.9766 32.5898C23.9766 32.1523 23.8906 31.7656 23.7188 31.4297C23.5547 31.0859 23.3008 30.8203 22.957 30.6328C22.6133 30.4375 22.1797 30.3398 21.6562 30.3398C21.2422 30.3398 20.8594 30.4219 20.5078 30.5859C20.1562 30.75 19.875 30.9805 19.6641 31.2773C19.4531 31.5742 19.3477 31.9336 19.3477 32.3555H15.9609C15.9609 31.418 16.2109 30.6016 16.7109 29.9062C17.2188 29.2109 17.8984 28.668 18.75 28.2773C19.6016 27.8867 20.5391 27.6914 21.5625 27.6914C22.7188 27.6914 23.7305 27.8789 24.5977 28.2539C25.4648 28.6211 26.1406 29.1641 26.625 29.8828C27.1094 30.6016 27.3516 31.4922 27.3516 32.5547C27.3516 33.0938 27.2266 33.6172 26.9766 34.125C26.7266 34.625 26.3672 35.0781 25.8984 35.4844C25.4375 35.8828 24.875 36.2031 24.2109 36.4453C23.5469 36.6797 22.8008 36.7969 21.9727 36.7969H19.6289V35.0039ZM19.6289 37.5703V35.8242H21.9727C22.9023 35.8242 23.7188 35.9297 24.4219 36.1406C25.125 36.3516 25.7148 36.6562 26.1914 37.0547C26.668 37.4453 27.0273 37.9102 27.2695 38.4492C27.5117 38.9805 27.6328 39.5703 27.6328 40.2188C27.6328 41.0156 27.4805 41.7266 27.1758 42.3516C26.8711 42.9688 26.4414 43.4922 25.8867 43.9219C25.3398 44.3516 24.6992 44.6797 23.9648 44.9062C23.2305 45.125 22.4297 45.2344 21.5625 45.2344C20.8438 45.2344 20.1367 45.1367 19.4414 44.9414C18.7539 44.7383 18.1289 44.4375 17.5664 44.0391C17.0117 43.6328 16.5664 43.125 16.2305 42.5156C15.9023 41.8984 15.7383 41.168 15.7383 40.3242H19.125C19.125 40.7617 19.2344 41.1523 19.4531 41.4961C19.6719 41.8398 19.9727 42.1094 20.3555 42.3047C20.7461 42.5 21.1797 42.5977 21.6562 42.5977C22.1953 42.5977 22.6562 42.5 23.0391 42.3047C23.4297 42.1016 23.7266 41.8203 23.9297 41.4609C24.1406 41.0938 24.2461 40.668 24.2461 40.1836C24.2461 39.5586 24.1328 39.0586 23.9062 38.6836C23.6797 38.3008 23.3555 38.0195 22.9336 37.8398C22.5117 37.6602 22.0117 37.5703 21.4336 37.5703H19.6289ZM38.1797 27.9023V45H34.8047V31.793L30.75 33.082V30.4219L37.8164 27.9023H38.1797ZM43.6875 32.1211V31.2188C43.6875 30.5703 43.8281 29.9805 44.1094 29.4492C44.3906 28.918 44.8047 28.4922 45.3516 28.1719C45.8984 27.8516 46.5703 27.6914 47.3672 27.6914C48.1875 27.6914 48.8711 27.8516 49.418 28.1719C49.9727 28.4922 50.3867 28.918 50.6602 29.4492C50.9414 29.9805 51.082 30.5703 51.082 31.2188V32.1211C51.082 32.7539 50.9414 33.3359 50.6602 33.8672C50.3867 34.3984 49.9766 34.8242 49.4297 35.1445C48.8828 35.4648 48.207 35.625 47.4023 35.625C46.5898 35.625 45.9062 35.4648 45.3516 35.1445C44.8047 34.8242 44.3906 34.3984 44.1094 33.8672C43.8281 33.3359 43.6875 32.7539 43.6875 32.1211ZM45.9258 31.2188V32.1211C45.9258 32.3945 45.9766 32.6562 46.0781 32.9062C46.1875 33.1484 46.3516 33.3477 46.5703 33.5039C46.7969 33.6523 47.0703 33.7266 47.3906 33.7266C47.7266 33.7266 48 33.6523 48.2109 33.5039C48.4219 33.3477 48.5781 33.1484 48.6797 32.9062C48.7812 32.6562 48.832 32.3945 48.832 32.1211V31.2188C48.832 30.9297 48.7773 30.6641 48.668 30.4219C48.5664 30.1719 48.4062 29.9727 48.1875 29.8242C47.9766 29.668 47.7031 29.5898 47.3672 29.5898C47.0547 29.5898 46.7891 29.668 46.5703 29.8242C46.3516 29.9727 46.1875 30.1719 46.0781 30.4219C45.9766 30.6641 45.9258 30.9297 45.9258 31.2188ZM51.8438 41.7188V40.8164C51.8438 40.1758 51.9844 39.5898 52.2656 39.0586C52.5547 38.5273 52.9727 38.1016 53.5195 37.7812C54.0742 37.4609 54.7539 37.3008 55.5586 37.3008C56.3711 37.3008 57.0508 37.4609 57.5977 37.7812C58.1445 38.1016 58.5586 38.5273 58.8398 39.0586C59.1211 39.5898 59.2617 40.1758 59.2617 40.8164V41.7188C59.2617 42.3594 59.1211 42.9453 58.8398 43.4766C58.5664 44.0078 58.1562 44.4336 57.6094 44.7539C57.0625 45.0742 56.3867 45.2344 55.582 45.2344C54.7695 45.2344 54.0859 45.0742 53.5312 44.7539C52.9766 44.4336 52.5547 44.0078 52.2656 43.4766C51.9844 42.9453 51.8438 42.3594 51.8438 41.7188ZM54.0938 40.8164V41.7188C54.0938 42 54.1562 42.2656 54.2812 42.5156C54.4062 42.7656 54.5781 42.9648 54.7969 43.1133C55.0234 43.2617 55.2852 43.3359 55.582 43.3359C55.957 43.3359 56.25 43.2617 56.4609 43.1133C56.6719 42.9648 56.8164 42.7656 56.8945 42.5156C56.9805 42.2656 57.0234 42 57.0234 41.7188V40.8164C57.0234 40.5352 56.9688 40.2734 56.8594 40.0312C56.75 39.7812 56.5859 39.582 56.3672 39.4336C56.1562 39.2773 55.8867 39.1992 55.5586 39.1992C55.2305 39.1992 54.957 39.2773 54.7383 39.4336C54.5273 39.582 54.3672 39.7812 54.2578 40.0312C54.1484 40.2734 54.0938 40.5352 54.0938 40.8164ZM56.3906 30.375L48.0586 43.7109L46.418 42.8438L54.75 29.5078L56.3906 30.375Z"
                      fill="#1F78B4"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_2734">
                      <rect width="75" height="75" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold">
            Amount of Repairs
          </h1>
          <p className="text-lime-400 text-center">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#26F32E"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#26F32E"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">05.25%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-blue active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>
          </div>
        </div>
        <div class="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl " onClick={() => {handleScroll(returnRef.current);}}>
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative left-1.5 top-1"
                  width="48"
                  height="48"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 14H6.67544C7.25646 14 7.54696 14 7.77888 14.1338C7.83745 14.1675 7.89245 14.2072 7.94303 14.2521C8.14326 14.4298 8.23513 14.7054 8.41886 15.2566L8.54415 15.6325C8.76416 16.2925 8.87416 16.6225 9.13605 16.8112C9.39794 17 9.7458 17 10.4415 17H13.5585C14.2542 17 14.6021 17 14.864 16.8112C15.1258 16.6225 15.2358 16.2925 15.4558 15.6325L15.5811 15.2566L15.5811 15.2566C15.7649 14.7054 15.8567 14.4298 16.057 14.2521C16.1075 14.2072 16.1625 14.1675 16.2211 14.1338C16.453 14 16.7435 14 17.3246 14H18C18.9319 14 19.3978 14 19.7654 13.8478C20.2554 13.6448 20.6448 13.2554 20.8478 12.7654C21 12.3978 21 11.9319 21 11V17C21 18.8856 21 19.8284 20.4142 20.4142C19.8284 21 18.8856 21 17 21H7C5.11438 21 4.17157 21 3.58579 20.4142C3 19.8284 3 18.8856 3 17V11C3 11.9319 3 12.3978 3.15224 12.7654C3.35523 13.2554 3.74458 13.6448 4.23463 13.8478C4.60218 14 5.06812 14 6 14Z"
                    fill="#7E869E"
                    fill-opacity="0.25"
                  />
                  <path
                    d="M3 11V11C3 11.9319 3 12.3978 3.15224 12.7654C3.35523 13.2554 3.74458 13.6448 4.23463 13.8478C4.60218 14 5.06812 14 6 14H6.67544C7.25646 14 7.54696 14 7.77888 14.1338C7.83745 14.1675 7.89245 14.2072 7.94303 14.2521C8.14326 14.4298 8.23513 14.7054 8.41886 15.2566L8.54415 15.6325C8.76416 16.2925 8.87416 16.6225 9.13605 16.8112C9.39794 17 9.7458 17 10.4415 17H13.5585C14.2542 17 14.6021 17 14.864 16.8112C15.1258 16.6225 15.2358 16.2925 15.4558 15.6325L15.5811 15.2566C15.7649 14.7054 15.8567 14.4298 16.057 14.2521C16.1075 14.2072 16.1625 14.1675 16.2211 14.1338C16.453 14 16.7435 14 17.3246 14H18C18.9319 14 19.3978 14 19.7654 13.8478C20.2554 13.6448 20.6448 13.2554 20.8478 12.7654C21 12.3978 21 11.9319 21 11V11"
                    stroke="#1F78B4"
                    stroke-width="1.2"
                  />
                  <path
                    d="M8 9L12 12M12 12L16 9M12 12L12 2"
                    stroke="#1F78B4"
                    stroke-width="1.2"
                  />
                  <path
                    d="M16 5H17C18.8856 5 19.8284 5 20.4142 5.58579C21 6.17157 21 7.11438 21 9V17C21 18.8856 21 19.8284 20.4142 20.4142C19.8284 21 18.8856 21 17 21H7C5.11438 21 4.17157 21 3.58579 20.4142C3 19.8284 3 18.8856 3 17V9C3 7.11438 3 6.17157 3.58579 5.58579C4.17157 5 5.11438 5 7 5H8"
                    stroke="#1F78B4"
                    stroke-width="1.2"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">03%</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold">
            Rate of returns
          </h1>
          <p className="text-lime-400 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L6.29289 7.70711L7 8.41421L7.70711 7.70711L7 7ZM2.79289 4.20711L6.29289 7.70711L7.70711 6.29289L4.20711 2.79289L2.79289 4.20711ZM7.70711 7.70711L11.2071 4.20711L9.79289 2.79289L6.29289 6.29289L7.70711 7.70711Z"
                    fill="#26F32E"
                  />
                  <path
                    d="M7 10.5L6.29289 11.2071L7 11.9142L7.70711 11.2071L7 10.5ZM2.79289 7.70711L6.29289 11.2071L7.70711 9.79289L4.20711 6.29289L2.79289 7.70711ZM7.70711 11.2071L11.2071 7.70711L9.79289 6.29289L6.29289 9.79289L7.70711 11.2071Z"
                    fill="#26F32E"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">12.38%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
        <div class="w-full flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl " onClick={() => {handleScroll(productionRef.current);}}>
          <div className="text-center  mt-4">
            <div className="text-center">
              <button className=" text-center rounded-full w-12  bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                <svg
                  className="relative left-0.5 top-0"
                  width="48"
                  height="48"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.1422 20.2176C24.5591 18.6619 24.6125 17.0312 24.2982 15.4516C23.984 13.8719 23.3107 12.3858 22.3302 11.108C21.3498 9.83025 20.0885 8.79517 18.644 8.08284C17.1996 7.3705 15.6106 7 14 7C12.3894 7 10.8004 7.3705 9.35597 8.08284C7.91149 8.79517 6.65024 9.83025 5.66979 11.108C4.68934 12.3858 4.01596 13.8719 3.70175 15.4516C3.38755 17.0312 3.44093 18.6619 3.85778 20.2176"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M14.8933 18.1793C15.462 19.0068 15.0621 20.2694 14 20.9992C12.938 21.7291 11.616 21.6498 11.0473 20.8223C10.4174 19.9057 8.18269 14.5862 6.93297 11.5619C6.72827 11.0665 7.33424 10.6501 7.72332 11.0187C10.0987 13.2696 14.2635 17.2627 14.8933 18.1793Z"
                    stroke="#1F78B4"
                  />
                  <path
                    d="M14 7V9.33333"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M6.57532 10.075L8.22523 11.7249"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M21.4247 10.075L19.7748 11.7249"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M24.1423 20.2173L21.8884 19.6134"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                  <path
                    d="M3.85773 20.2173L6.11155 19.6134"
                    stroke="#1F78B4"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <h1 className="text-4xl text-center font-bold mt-4">07%</h1>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold">
            Total Production Cycle
          </h1>
          <p className="text-red-600 text-center mb-1">
            <span>
              <span className="inline-block">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#F32626"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#F32626"
                  />
                </svg>
              </span>
            </span>
            <span className="ml-1 font-medium">03.88%</span>
          </p>
          <div className="text-center flex justify-center ml-auto mt-1 mb-4">
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                Y
              </button>
            </div>
            <div className="">
              <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                M
              </button>
            </div>

            <div className="">
              <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                {" "}
                W
              </button>
            </div>
          </div>
        </div>
      </div>
      <Leadtime /> 
     <div ref={issueRef}> <Productionissues  /> </div>
     <div ref={repairRef}> <Productionrepair  /> </div>
     <div ref={returnRef}>  <Productreturn  /> </div>
     <div ref={productionRef}> <Productioncycle /> </div>

      

    </div>
  );
}
